<template>
  <div class="design-split">
    <section class="split-hero">
      <div class="split-hero__left">
        <front-page-design-nav theme="light" :show-links="false" />
        <div class="split-hero__content">
          <img :src="logo" alt="BOX21" class="split-hero__logo" />
          <h1>{{ hero.line1 }}</h1>
          <h2>{{ hero.line2 }}</h2>
          <p class="split-hero__line3">{{ hero.line3 }}</p>
          <div class="split-hero__actions">
            <button type="button" class="btn btn--fill" @click="goToRegister">Get started</button>
            <button type="button" class="btn btn--line" @click="goToLogin">Login</button>
          </div>
        </div>
      </div>
      <div class="split-hero__right">
        <v-img :src="heroImage" cover class="split-hero__image">
          <animated-box top="44" left="40.5" width="12" height="23" :title="$t('frontpage.animated_box8')" subtitle="0.89" />
          <animated-box top="35" left="56.5" width="8.9" height="12.2" :title="$t('frontpage.animated_box4')" subtitle="0.94" />
          <animated-box top="65" left="78.5" width="2.8" height="5.7" :title="$t('frontpage.animated_box_bird')" subtitle="0.98" />
        </v-img>
      </div>
    </section>

    <front-page-asset-strip />

    <section class="pillars">
      <article v-for="pillar in pillars" :key="pillar.id" class="pillar-card">
        <img :src="pillar.icon" :alt="pillar.title" />
        <h3>{{ pillar.title }}</h3>
        <span v-for="tag in pillar.tags" :key="tag">{{ tag }}</span>
      </article>
    </section>

    <front-page-design-footer theme="light" />
  </div>
</template>

<script>
import FrontPageDesignNav from '@/components/front_page/designs/FrontPageDesignNav.vue'
import FrontPageDesignFooter from '@/components/front_page/designs/FrontPageDesignFooter.vue'
import FrontPageAssetStrip from '@/components/front_page/FrontPageAssetStrip.vue'
import AnimatedBox from '@/components/front_page/AnimatedBox.vue'
import { BRAND, HERO, PILLARS, HERO_IMAGE } from '@/components/front_page/designs/shared'

export default {
  name: 'DesignSplit',
  components: { FrontPageDesignNav, FrontPageDesignFooter, FrontPageAssetStrip, AnimatedBox },
  data() {
    return {
      logo: BRAND.logo,
      hero: HERO,
      pillars: PILLARS,
      heroImage: HERO_IMAGE,
    }
  },
  methods: {
    goToLogin() { this.$router.push('/login') },
    goToRegister() { this.$router.push({ path: '/login', query: { tab: 'register' } }) },
  },
}
</script>

<style scoped>
.design-split {
  min-height: 100vh;
  background: #fff;
  font-family: system-ui, sans-serif;
}

.split-hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 85vh;
}

.split-hero__left {
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}

.split-hero__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 48px 64px;
}

.split-hero__logo {
  height: 44px;
  margin-bottom: 32px;
}

.split-hero h1 {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  margin: 0;
  color: #0677b9;
  letter-spacing: -0.03em;
}

.split-hero h2 {
  font-size: clamp(1.5rem, 3vw, 2.25rem);
  font-weight: 600;
  margin: 8px 0 0;
  color: #333;
}

.split-hero__line3 {
  font-size: 1.15rem;
  color: #666;
  margin: 20px 0 32px;
}

.split-hero__actions {
  display: flex;
  gap: 12px;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  font-family: inherit;
}

.btn--fill {
  background: #0677b9;
  color: #fff;
}

.btn--line {
  background: transparent;
  border: 2px solid #0677b9;
  color: #0677b9;
}

.split-hero__right {
  position: relative;
  min-height: 400px;
}

.split-hero__image {
  height: 100%;
  min-height: 85vh;
}

.pillars {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  background: #ddd;
  margin: 0;
}

.pillar-card {
  background: #fff;
  padding: 32px 24px;
  text-align: center;
}

.pillar-card img {
  width: 44px;
  height: 44px;
  margin-bottom: 16px;
}

.pillar-card h3 {
  font-size: 1rem;
  margin: 0 0 12px;
}

.pillar-card span {
  display: inline-block;
  font-size: 0.75rem;
  color: #0677b9;
  margin: 0 4px;
}

@media (max-width: 900px) {
  .split-hero {
    grid-template-columns: 1fr;
  }
  .split-hero__image {
    min-height: 50vh;
  }
  .pillars {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
